import { Stack, Typography, Box } from '@mui/material';
import { ProfilePhoto } from 'components/ProfilePhoto';
import { useOrganisationPersonalWebshop } from 'hooks/useOrganisationPersonalWebshop';
import { useServerTranslation } from 'hooks/useServerTranslation';
import useConsultantWebshop from 'stores/useConsultantWebshop';
import { colors } from 'styles/theme/colors';

export function ConsultantWebshopProfile() {
    const { t } = useServerTranslation();
    const { isConsultantRoute } = useOrganisationPersonalWebshop();
    const consultant = useConsultantWebshop();

    if (!isConsultantRoute || consultant.id === 0) {
        return null;
    }

    return (
        <Stack
            sx={{
                justifyContent: 'space-between',
                rowGap: 1.5,
                flexGrow: 1,
            }}
        >
            <Typography color={colors.gray} sx={{ fontSize: '0.75rem' }}>
                {t('consultant-webshop.title')}
            </Typography>
            <Box sx={{ display: 'flex', columnGap: 2 }}>
                <Box
                    sx={{
                        '& img': { borderRadius: '50%' },
                    }}
                >
                    <ProfilePhoto
                        src={consultant.profile_photo_path}
                        width={45}
                        height={45}
                    />
                </Box>
                <Stack spacing={0.25}>
                    <Typography sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
                        {consultant.fullName}
                    </Typography>
                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 300 }}>
                        {consultant.title_name_long}
                    </Typography>
                </Stack>
            </Box>
        </Stack>
    );
}
